import { listByType, SysHeader, getReimbursementType } from '@/http/url.js'
const state = {
    dasset_typeList: [], // 处置类型
    positionList: [], //行政职务
    positionLevelList: [], //职级
    politicalTypeList: [], //政治面貌
    contractTypeList: [], //劳动合同类型
    educationList: [], //学历
    registeredNatureList: [], //户口性质
    healthStatusList: [], //健康状态
    positionStatusList: [], //减员原因
    dutiesValList: [], //职务    用户表用
    reportTimeList: [], //时间
    paymentwayValList: [], // 付款方式
    documentTypeList: [], // 发文分类
    pgHeaderList: [], // 页头
    classificationList: [], // 	信息的分类
    boilerTypeList: [], // 锅炉使用状态
    whetherList: [], // 是否持证上岗
    auditTypeList: [], // 审计类型
    carApplicationTypeList: [], // 公务用车type
    retirePositionStatus: [],//退休减员原因
    outReimbursementTypeList: [], // 门诊报销类型
    hosptReimbursementTypeList: [], // 住院报销类型
    warmReimbursementTypeList: [], // 取暖报销类型
    outReimbursementRateList: [], // 门诊报销比例
    hosptReimbursementRateList: [], // 住院报销比例
    warmReimbursementRateList: [], // 取暖报销比例
    retireTypeList: [], // 退休类别
    invoiceTypeList: [], // 取暖费发票类型

}

const mutations = {
    outReimbursementRateList: (state, outReimbursementRateList) => {
        state.outReimbursementRateList = outReimbursementRateList
    },
    hosptReimbursementRateList: (state, hosptReimbursementRateList) => {
        state.hosptReimbursementRateList = hosptReimbursementRateList
    },
    warmReimbursementRateList: (state, warmReimbursementRateList) => {
        state.warmReimbursementRateList = warmReimbursementRateList
    },

    outReimbursementTypeList: (state, outReimbursementTypeList) => {
        state.outReimbursementTypeList = outReimbursementTypeList
    },
    hosptReimbursementTypeList: (state, hosptReimbursementTypeList) => {
        state.hosptReimbursementTypeList = hosptReimbursementTypeList
    },
    warmReimbursementTypeList: (state, warmReimbursementTypeList) => {
        state.warmReimbursementTypeList = warmReimbursementTypeList
    },
    setReimbursementRateList: (state, reimbursementRateList) => {
        state.reimbursementRateList = reimbursementRateList
    },
    setcarApplicationTypeList: (state, carApplicationTypeList) => {
        state.carApplicationTypeList = carApplicationTypeList
    },
    whetherList: (state, whetherList) => {
        state.whetherList = whetherList
    },
    boilerTypeList: (state, boilerTypeList) => {
        state.boilerTypeList = boilerTypeList
    },
    setDasset_typeList: (state, dasset_typeList) => {
        state.dasset_typeList = dasset_typeList
    },
    setpositionList: (state, positionList) => {
        state.positionList = positionList
    },
    setpositionLevelList: (state, positionLevelList) => {
        state.positionLevelList = positionLevelList
    },
    setpoliticalTypeList: (state, politicalTypeList) => {
        state.politicalTypeList = politicalTypeList
    },
    setcontractTypeList: (state, contractTypeList) => {
        state.contractTypeList = contractTypeList
    },
    seteducationList: (state, educationList) => {
        state.educationList = educationList
    },
    setregisteredNatureList: (state, registeredNatureList) => {
        state.registeredNatureList = registeredNatureList
    },
    setpositionStatusList: (state, positionStatusList) => {
        state.positionStatusList = positionStatusList
    },
    //retirePositionStatus
    setretirePositionStatus: (state, retirePositionStatus) => {
        state.retirePositionStatus = retirePositionStatus
    },
    setdutiesValList: (state, dutiesValList) => {
        state.dutiesValList = dutiesValList
    },
    sethealthStatusList: (state, healthStatusList) => {
        state.healthStatusList = healthStatusList
    },
    setreportTimeList: (state, reportTimeList) => {
        state.reportTimeList = reportTimeList
    },
    setpaymentwayValList: (state, paymentwayValList) => {
        state.paymentwayValList = paymentwayValList

    },
    setdocumentTypeList: (state, documentTypeList) => {
        state.documentTypeList = documentTypeList

    },
    setpgHeaderList: (state, pgHeaderList) => {
        state.pgHeaderList = pgHeaderList
    },
    setclassificationList: (state, classificationList) => {
        state.classificationList = classificationList
    },
    setauditTypeList: (state, auditTypeList) => {
        state.auditTypeList = auditTypeList
    },
    setRetireTypeList: (state, retireTypeList) => {
        state.retireTypeList = retireTypeList
    },
    setInvoiceTypeList: (state, invoiceTypeList) => {
        state.invoiceTypeList = invoiceTypeList
    },
}
const actions = {
    // 报销类型
    async getReimbursementTypeFn({ commit }, params) {
        /*
            type	报销类型 1 取暖 2 住院 3 门诊 
            workersType	职工类型 1 自助（退休） 2 在职 3 代客
        */
        await getReimbursementType(params).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    let commitName
                    if (params.reimbursementGroup) {
                        if (params.type == 3) {
                            commitName = 'outReimbursementRateList'
                        } else if (params.type == 2) {
                            commitName = 'hosptReimbursementRateList'
                        } else if (params.type == 1) {
                            commitName = 'warmReimbursementRateList'
                        }
                        commit(commitName, res.data.data.proportion)
                    } else {
                        if (params.type == 3) {
                            commitName = 'outReimbursementTypeList'
                        } else if (params.type == 2) {
                            commitName = 'hosptReimbursementTypeList'
                        } else if (params.type == 1) {
                            commitName = 'warmReimbursementTypeList'
                        }
                        commit(commitName, res.data.data)
                    }

                }
            }
        })
    },

    // 获取用车type
    async getcarApplicationTypeList({ commit }) {
        await listByType({ type: 'carApplicationType' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setcarApplicationTypeList', res.data.data)
                }
            }
        })
    },
    // 获取是否相关的option
    async getWhetherList({ commit }) {
        await listByType({ type: 'whether' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('whetherList', res.data.data)
                }
            }
        })
    },
    // 获取锅炉使用状态
    async getBoilerTypeList({ commit }) {
        await listByType({ type: 'boilerType' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('boilerTypeList', res.data.data)
                }
            }
        })
    },
    // 获取处置类型字典表
    async getdasset_type({ commit }) {
        await listByType({ type: 'dasset_type' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setDasset_typeList', res.data.data)
                }
            }
        })
    },
    // 行政职务
    async getposition({ commit }) {
        await listByType({ type: 'position' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setpositionList', res.data.data)
                }
            }
        })
    },
    // 职级
    async getpositionLevel({ commit }) {
        await listByType({ type: 'positionLevel' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setpositionLevelList', res.data.data)
                }
            }
        })
    },
    // 政治面貌
    async getpoliticalType({ commit }) {
        await listByType({ type: 'politicalType' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setpoliticalTypeList', res.data.data)
                }
            }
        })
    },
    // 劳动合同类型
    async getcontractType({ commit }) {
        await listByType({ type: 'contractType' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setcontractTypeList', res.data.data)
                }
            }
        })
    },
    // 学历
    async geteducation({ commit }) {
        await listByType({ type: 'education' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('seteducationList', res.data.data)
                }
            }
        })
    },
    // 户口性质
    async getregisteredNature({ commit }) {
        await listByType({ type: 'registeredNature' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setregisteredNatureList', res.data.data)
                }
            }
        })
    },
    // 健康状态
    async gethealthStatus({ commit }) {
        await listByType({ type: 'healthStatus' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('sethealthStatusList', res.data.data)
                }
            }
        })
    },
    // 减员原因
    async getpositionStatus({ commit }) {
        await listByType({ type: 'positionStatus' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setpositionStatusList', res.data.data)
                }
            }
        })
    },
    //退休减员原因 retirePositionStatus
    async getretirePositionStatus({ commit }) {
        await listByType({ type: 'retirePositionStatus' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setretirePositionStatus', res.data.data)
                }
            }
        })
    },
    // 职务
    async getdutiesVal({ commit }) {
        await listByType({ type: 'duties_type' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setdutiesValList', res.data.data)
                }
            }
        })
    },
    // 时间
    async getreportTime({ commit }) {
        await listByType({ type: 'reportTime' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setreportTimeList', res.data.data)
                }
            }
        })
    },
    // 付款方式
    async getpaymentwayVal({ commit }) {
        await listByType({ type: 'paymentMethod' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setpaymentwayValList', res.data.data)
                }
            }
        })
    },
    // 发文分类
    async getdocumentType({ commit }) {
        await listByType({ type: 'documentType' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setdocumentTypeList', res.data.data)
                }
            }
        })
    },
    // 页头
    async getpgHeader({ commit }) {
        await SysHeader().then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setpgHeaderList', res.data.data)
                }
            }
        })
    },
    // 信息的分类
    async getclassification({ commit }) {
        await listByType({ type: 'classification' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setclassificationList', res.data.data)
                }
            }
        })
    },
    // 审计类型
    async getauditType({ commit }) {
        await listByType({ type: 'auditType' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setauditTypeList', res.data.data)
                }
            }
        })
    },
    // 退休类别
    async getRetireTypeList({ commit }) {
        await listByType({ type: 'retireType' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setRetireTypeList', res.data.data)
                }
            }
        })
    },
    // 取暖费发票类型
    async getInvoiceTypeList({ commit }) {
        await listByType({ type: 'invoiceType' }).then(res => {
            if (res) {
                if (res.data.code == 0) {
                    commit('setInvoiceTypeList', res.data.data)
                }
            }
        })
    },
}

export default {
    // namespaced: true, // 命名空间如果打开调用方式要加路径
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/bytype.js